import generate from './generate';
import OptionList from './OptionList';
var TreeSelect = generate({
  prefixCls: 'rc-tree-select',
  optionList: OptionList
});
export default TreeSelect;